import { buttonVariants } from "@/components/ui/button";
import { Link } from "@inertiajs/react";
import AdminLayout from "./layout";

export default function Component() {
  return (
    <AdminLayout pageName="testing">
      <div>
        <h1 className="text-2xl font-bold">Testing</h1>

        <div className="mt-4 space-y-2">
          <div>
            <Link
              href="/admin/testing/server_error"
              className={buttonVariants({ variant: "outline" })}
            >
              Trigger Server Error
            </Link>
          </div>

          <div>
            <Link href="/admin/uitest" className={buttonVariants({ variant: "outline" })}>
              UI TEsting
            </Link>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
